import React from 'react'
import styles from './styles.module.scss'
import { useNavigate } from 'react-router-dom'
import routes from '../../routes/routes'
import { Menu } from '../../components/Menu/Menu'
import { get } from '../../utils/session-handler'
import constants from '../../utils/constants'

export function CallHistoryPage() {
  const navigate = useNavigate()
  const JUDITE_URL = constants.JUDITE_URL
  const recentContacts = get('recentContacts') !== undefined ? JSON.parse(get('recentContacts')) : []

  const handleCall = (phoneNumber) => {
    navigate(routes.OutgoingCallPage.path, {
      replace: true,
      state: phoneNumber,
    })
  }

  return (
    <main className={styles.mainWrapper}>
      <div className={styles.title}>Ligações Recentes</div>
      <div className={styles.divider} />
      <ul>
        {recentContacts.map(contact => (
          <li key={contact.id}>

            {contact.isAccept 
              ? <img src={`${JUDITE_URL}/PhoneAccept.svg`} /> 
              : <img src={`${JUDITE_URL}/PhoneDecline.svg`} />
            }

            <span className={styles.phoneNumber} onClick={() => handleCall(contact.callNumber)}>{contact.callNumber}</span>
            <span>{contact.callHours},</span>
            <span>{contact.callDate}</span>
            <span>({contact.callTimer})</span>
            <div className={styles.dividerList} />
          </li>
        ))}
      </ul> 

      <Menu state='Recentes'/>
    </main>
  )
}
